import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router-dom';
import { TEXT_COLOR } from '../constants/colours'
import { HashLink } from 'react-router-hash-link';
import language from '../constants/languages'

export default class AboutUsButton extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    return (
      <div>
        <RaisedButton
          className="text-color"
          onClick={this.handleClick}
          label={language[this.props.selectedLanguage].about_us}
          labelColor={TEXT_COLOR}
          style={{margin:10}}
        />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          onRequestClose={this.handleRequestClose}
        >
          <Menu onItemClick = {this.handleRequestClose}>
            <MenuItem containerElement={<Link to="/about_us" />} primaryText="About Us" />
            <MenuItem containerElement={<HashLink to="/about_us#team" />} primaryText="Team" />
            <MenuItem containerElement={<Link to="/contact" />} primaryText="Contact Us" />
          </Menu>
        </Popover>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutUsButton.js